import React, { useState } from 'react'
import { ChevronDown, Settings, LogOut } from 'lucide-react'
import { useAppContext } from '@/app/AppContext'
import { isAdmin } from '@/auth/AuthRoles'
import { Avatar, Menu, MenuItem } from '@/components/ui'

const AvatarMenu: React.FC = () => {
  const { user, setCurrentPath } = useAppContext()
  const [open, setOpen] = useState(false)
  if (!user) return null

  const displayName = user.name || user.email
  const admin = isAdmin(user.roles)

  const go = (path: string) => { setOpen(false); setCurrentPath(path) }

  return (
    <div className="topbar__user">
      <button className="avatar-pill" onClick={() => setOpen((o) => !o)} aria-haspopup="menu" aria-expanded={open}>
        <Avatar name={displayName} size={34} />
        <span className="avatar-pill__text">
          <span className="avatar-pill__name">{displayName}</span>
          <span className="avatar-pill__role">{admin ? 'Admin' : 'User'}</span>
        </span>
        <span className="avatar-pill__chev"><ChevronDown size={16} /></span>
      </button>
      <Menu open={open} onClose={() => setOpen(false)} style={{ position: 'absolute', top: 52, right: 0 }}>
        <div className="menu__header">
          <div className="menu__header-name">{displayName}</div>
          <div className="menu__header-email">{user.email}</div>
        </div>
        <MenuItem icon={<Settings size={17} />} onClick={() => go('/settings')}>Settings</MenuItem>
        <MenuItem icon={<LogOut size={17} />} danger onClick={() => go('/logout')}>Log out</MenuItem>
      </Menu>
    </div>
  )
}

export default AvatarMenu
